import moment from 'moment';
import { SystemState } from '../../redux/type';
import { CLSTAG } from '@/utils/constant';
const formatBoardItem = (data: any, vehicle: Vehicle) => {
  const {
    schedule,
    vehicleBusinessType,
    scheduleState,
    speed,
    power,
    alarmEventList,
    systemState,
    vehicleName,
    vehicleState,
    taskType,
    recordTime,
  } = data;
  const {
    stopList,
    totalOrderNum,
    globalMileage,
    arrivedMileage,
    totalArrivedMileage,
    finishedOrderNum,
    currentStopFinishedMileage,
  } = schedule || {};
  const stopData = formatStopList(stopList, currentStopFinishedMileage);
  const alarmEvent =
    systemState == 'CONNECTION_LOST'
      ? [
          {
            reportTime: recordTime,
            alarmEvent: '',
          },
        ]
      : alarmEventList;

  return {
    id: vehicleName,
    name: vehicleName,
    stationName: vehicle[vehicleName] && vehicle[vehicleName].stationName,
    scheduleState: scheduleState, // 配送
    alarmEvent: alarmEvent ?? [], // 报警及处理方案
    systemState: systemState, // 系统
    vehicleState: vehicleState, // 车辆状态 vehicleState
    currentStopFinishedMileage:
      (currentStopFinishedMileage &&
        (currentStopFinishedMileage / 1000).toFixed(2)) ||
      0,
    mileage: (arrivedMileage && (arrivedMileage / 1000).toFixed(2)) || 0,
    mileageTotal: (globalMileage && (globalMileage / 1000).toFixed(2)) || 0,
    totalTraveledMileage:
      (totalArrivedMileage && (totalArrivedMileage / 1000).toFixed(2)) || 0, // 整段已走里程
    speed: (speed && speed.toFixed(2)) ?? 0,
    power: power && power.toFixed(0),
    totalOrderNum: totalOrderNum || 0,
    finishedOrderNum: finishedOrderNum || 0,
    license: vehicleName,
    vehicleBusinessType: vehicleBusinessType,
    stopList: stopData || [],
    taskType: taskType,
  };
};

export function formatConnectLostAndExpGroup(groudData: any, vehicle: Vehicle) {
  if (!groudData || !groudData.multiVehiclePageList) {
    return [];
  }
  const initGroup = new Map([
    [
      'CONNECTION_LOST',
      {
        total: 0,
        data: [],
        label: '失联',
      },
    ],
    [
      'VEHICLE_CRASH',
      {
        total: 0,
        data: [],
        label: '防撞',
      },
    ],
    ['HARDWARE_ERROR', { label: '硬件异常', total: 0, data: [] }],
    ['NETWORK_SIGNAL', { label: '网络信号', total: 0, data: [] }],
    [
      'MANUAL_REPORT',
      {
        total: 0,
        data: [],
        label: '人工告警',
      },
    ],
    [
      'CALIBRATION_ERROR',
      {
        total: 0,
        data: [],
        label: '标定',
      },
    ],
    [
      'SENSOR_ERROR',
      {
        total: 0,
        data: [],
        label: '传感器异常',
      },
    ],
    [
      'OPERATION_ALARM',
      {
        total: 0,
        data: [],
        label: '运营告警',
      },
    ],
    [
      'BOOT_ALARM',
      {
        total: 0,
        data: [],
        label: '开机异常',
      },
    ],
    [
      'INTERSECTION_ABNORMAL',
      {
        total: 0,
        data: [],
        label: '路口异常',
      },
    ],
    [
      'STOP',
      {
        total: 0,
        data: [],
        label: '停车',
      },
    ],
    [
      'CLOUD_WARN',
      {
        total: 0,
        data: [],
        label: '云端预警',
      },
    ],
    [
      'LOW_BATTERY',
      {
        total: 0,
        data: [],
        label: '电量',
      },
    ],
    [
      'LOW_PRESSURE',
      {
        total: 0,
        data: [],
        label: '胎压',
      },
    ],
  ]);
  groudData.multiVehiclePageList.forEach((groupItem: any) => {
    const { category, list, total } = groupItem;
    if (!initGroup.has(category)) {
      return;
    }

    const value: any = initGroup.get(category);
    value.total = total;
    list?.forEach((item: any) => {
      value.data.push(formatBoardItem(item, vehicle));
    });
  });
  return initGroup;
}

export const formatBoardGroupByFilterType = (
  boardData: BoardData,
  vehicles: Vehicle
) => {
  if (!boardData || !boardData.multiVehiclePageList) {
    return [];
  }
  const boardGroup: any[] = [];
  const { multiVehiclePageList } = boardData;
  multiVehiclePageList.forEach((groupItem: BoardGroupItem, index: number) => {
    groupItem.list &&
      groupItem.list.forEach((vehicle: BoardItem, itemIndex: number) => {
        boardGroup.push(formatBoardItem(vehicle, vehicles));
      });
  });
  return boardGroup;
};

const formatStopList = (stopList: StopItem[], finishedMileage: number) => {
  return (
    stopList &&
    stopList.map((item: StopItem, index: number) => {
      let percent = 0;
      if (['STAY', 'DEPART', 'SKIP'].includes(item.travelStatus)) {
        percent = 100;
      } else if (item.travelStatus === 'START') {
        percent = (finishedMileage / item.globalMileage) * 100;
      } else {
        percent = 0;
      }

      if (percent < 0) {
        percent = 0;
      }

      return {
        ...item,
        percent: percent >= 100 ? 100 : percent,
        estDepartTime:
          item.estDepartTime && moment(item.estDepartTime).format('HH:mm'),
        arrivedTime:
          (item.arrivedTime && new Date(item.arrivedTime).getTime()) || 0,
        time:
          item &&
          item.arrivedTime &&
          item.waitingTime &&
          item.waitingTime * 60000 -
            (new Date().getTime() - new Date(item.arrivedTime).getTime()),
      };
    })
  );
};

export const Mode = [
  {
    label: '看板模式',
    value: 'boardMode',
    isActive: true,
    clstag: CLSTAG.MultiPage_BoardMode,
  },
  {
    label: '地图模式',
    value: 'mapMode',
    isActive: false,
    clstag: CLSTAG.MultiPage_MapMode,
  },
];
